import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();

  const changeLanguage = (lang: string) => {
    i18n.changeLanguage(lang);
    // Update html lang attribute
    document.documentElement.lang = lang;
  };

  const currentLanguage = i18n.language;

  return (
    <div className="flex items-center gap-2">
      <Globe className="w-5 h-5 text-neutral-600" aria-hidden="true" />
      <div className="flex items-center gap-1 rounded-lg bg-neutral-100 p-1">
        <button
          onClick={() => changeLanguage('en')}
          className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
            currentLanguage === 'en'
              ? 'bg-white text-primary-600 shadow-sm'
              : 'text-neutral-600 hover:text-neutral-900'
          }`}
          aria-label="Switch to English"
          aria-pressed={currentLanguage === 'en'}
        >
          EN
        </button>
        <button
          onClick={() => changeLanguage('km')}
          className={`px-3 py-1.5 rounded-md text-sm font-medium transition-all ${
            currentLanguage === 'km'
              ? 'bg-white text-primary-600 shadow-sm'
              : 'text-neutral-600 hover:text-neutral-900'
          }`}
          aria-label="Switch to Khmer"
          aria-pressed={currentLanguage === 'km'}
        >
          KH
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
